import { ErrorButtonPage } from 'apps/shell/src/pages/ErrorButtonPage';

interface Props {
  error: Error;
}

export function AuthenticationFailure({ error }: Props) {
  return (
    <ErrorButtonPage
      title="The Okta authentication has failed."
      content={`${error.message} Please reach out to your administrator for assistance.`}
      buttonLabel="Retry"
      buttonUrl="/"
    />
  );
}
